<template>
  <DynamicModal
    :showModal="showModalProp"
    :persistent="false"
    @clickOutside="closeModal"
    title="Total Time"
    maxWidth="700px"
  >
    <v-container fluid slot="title-buttons" class="py-1">
      <v-row justify="end">
        <v-btn
          icon
          depressed
          color="primary"
          @click="closeModal"
        >
          <v-icon color="white">close</v-icon>
        </v-btn>
      </v-row>
    </v-container>
    <v-container fluid slot="content">
      <v-form ref="form" lazy-validation>
        <v-row class="mt-3">
          <v-col cols="12" sm="4">
            <FormattedNumberField
              label="Total Hours"
              :value="dayLog.workedTime"
              :rules="[isValid]"
              :validateOnBlur="true"
              :readonly="readonly"
              @valueChange="(newValue) => this.dayLog.workedTime = newValue"
            ></FormattedNumberField>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-textarea
              label="Details"
              v-model="dayLog.details"
              :readonly="readonly"
              outlined
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
    <v-container fluid slot="buttons" class="pb-0 mb-0">
      <div class="row d-flex justify-end">
        <div class="col-6" v-if="!readonly">
          <v-btn
            color="primary"
            block
            depressed
            @click="acceptHandler"
          >
            Accept
          </v-btn>
        </div>
        <div :class="readonly ? 'col-12' : 'col-6' ">
          <v-btn
            block
            depressed
            outlined
            @click="closeModal"
          >
           {{ readonly ? 'Close' : 'Cancel' }}
          </v-btn>
        </div>
      </div>
    </v-container>
  </DynamicModal>
</template>
<script>
import { DynamicModal } from '@/components/dialogs'
import { FormattedNumberField } from '@/components/shared/textFields'
import { UPLOADED_TO_TIME_SHEET_ENTRIES } from '@/lib/constants/clockLogStates'

export default {
  components: {
    DynamicModal,
    FormattedNumberField
  },
  props: [
    'readonly'
  ],
  data () {
    return {
      UPLOADED_TO_TIME_SHEET_ENTRIES,
      showModalProp: false,
      dayLog: {
        workedTime: null,
        details: null
      }
    }
  },
  methods: {
    isValid (value) {
      return !isNaN(parseInt(value)) && value >= 0 ? true : 'Total Hours is Required'
    },
    showModal (dayLog) {
      this.dayLog = dayLog
      this.dayLog.details = dayLog.details
      this.showModalProp = true
    },
    closeModal () {
      this.showModalProp = false
      this.$emit('closeTimeEdit')
      this.dayLog = {
        workedTime: null,
        details: null
      }
    },
    acceptHandler () {
      if (this.$refs.form.validate()) {
        this.dayLog.hasAnyError = null
        this.dayLog.state = this.EDITED
        this.$emit('totalTimeChanged', this.dayLog)
        this.closeModal()
      }
    }
  }
}
</script>
